/* saved-drawer.js — hand-authored, NOT part of the webpack app.js bundle.
 *
 * Implements the "Saved items" feature with no build step:
 *   • Clicking a save button (.js-wishlist-toggle) stores/removes the product in
 *     localStorage, opens the Saved drawer, and reflects the saved state.
 *   • The Saved drawer ([data-saved-panel], snippets/saved-drawer.liquid) reuses
 *     the cart drawer's panel--cart classes, so open/close mirrors cart-panel.js
 *     (desktop dropdown + mobile bottom-sheet).
 *   • The header save icon (.js-saved-trigger) opens the drawer and turns solid
 *     (.has-saved) whenever at least one item is saved.
 *
 * Loaded with `defer` after app.js so it shares the same DOM-ready timing.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'grwn:saved';
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var isMobile = function () { return mqMobile.matches; };

  /* ---- storage ------------------------------------------------------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function indexOf(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return i;
    }
    return -1;
  }

  function init() {
    var panel = document.querySelector('[data-saved-panel]');
    if (!panel) return;

    var template = document.querySelector('.js-saved-item-template');
    var listEl = panel.querySelector('.js-saved-items');
    var emptyEl = panel.querySelector('.js-saved-empty');
    var headerRight = document.querySelector('.header__right');
    var header = document.querySelector('.header');
    var lockTargets = [document.documentElement, document.body];

    // Match cart-panel.js: relocate into .header__right so the panel inherits the
    // same desktop header dropdown sizing/positioning.
    if (headerRight) headerRight.appendChild(panel);

    /* ---- header save icon + button states --------------------------- */
    function syncIndicators() {
      var count = read().length;
      var ids = read().map(function (i) { return String(i.id); });

      document.querySelectorAll('.js-saved-trigger').forEach(function (el) {
        el.classList.toggle('has-saved', count > 0);
      });
      document.querySelectorAll('.js-wishlist-toggle[data-product-id]').forEach(function (btn) {
        btn.classList.toggle('is-saved', ids.indexOf(String(btn.getAttribute('data-product-id'))) !== -1);
      });
    }

    /* ---- render list ------------------------------------------------ */
    function render() {
      var items = read();
      listEl.innerHTML = '';

      if (!items.length) {
        listEl.classList.add('hidden');
        emptyEl.classList.remove('hidden');
        emptyEl.classList.add('flex');
      } else {
        listEl.classList.remove('hidden');
        emptyEl.classList.add('hidden');
        emptyEl.classList.remove('flex');

        items.forEach(function (item) {
          var node = template.content.firstElementChild.cloneNode(true);
          node.setAttribute('data-id', item.id);

          var titleLink = node.querySelector('.js-saved-link');
          titleLink.textContent = item.title || '';
          titleLink.href = item.url || '#';

          node.querySelector('.js-saved-price').textContent = item.price || '';

          var viewLink = node.querySelector('.js-saved-view');
          if (viewLink) viewLink.href = item.url || '#';

          var imgLink = node.querySelector('.js-saved-image-link');
          imgLink.href = item.url || '#';
          var img = node.querySelector('.js-saved-image');
          if (item.image) {
            img.src = item.image;
            img.alt = item.title || '';
          } else {
            img.remove();
          }

          listEl.appendChild(node);
        });
      }
      syncIndicators();
    }

    /* ---- open / close (mirrors cart-panel.js) ----------------------- */
    function updatePanelTop() {
      var anchor = document.querySelector('.header__logo');
      if (!anchor) return;
      var rect = anchor.getBoundingClientRect();
      document.documentElement.style.setProperty('--cart-panel-top', rect.bottom + 40 + 'px');
    }
    function isOpen() {
      return isMobile() ? panel.classList.contains('is-open') : !panel.classList.contains('hidden');
    }
    function closeCart() {
      var cart = document.querySelector('[data-cart-panel]');
      if (cart) {
        cart.classList.add('hidden');
        cart.classList.remove('is-open', 'is-dragging');
        cart.style.transform = '';
        cart.setAttribute('aria-hidden', 'true');
      }
      if (header) header.classList.remove('header--cart-open');
    }
    function open() {
      if (isOpen()) return;
      closeCart();
      // The fixed header slides up (.header--hidden) on scroll-down; since the
      // panel is nested in it, bring the header back so the panel isn't rendered
      // translated off-screen. See keepHeaderVisibleWhenLocked() for the others.
      if (header) header.classList.remove('header--hidden');
      if (isMobile()) {
        updatePanelTop();
        panel.classList.remove('hidden');
        panel.setAttribute('aria-hidden', 'false');
        void panel.offsetWidth;
        panel.classList.add('is-open');
      } else {
        panel.classList.remove('hidden');
        panel.setAttribute('aria-hidden', 'false');
        if (header) header.classList.add('header--menu-open', 'header--saved-open');
      }
      lockTargets.forEach(function (el) { el.classList.add('is-locked'); });
    }
    function close() {
      if (!isOpen()) return;
      if (isMobile()) {
        panel.classList.remove('is-open', 'is-dragging');
        panel.style.transform = '';
        panel.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
          if (!panel.classList.contains('is-open')) panel.classList.add('hidden');
        }, 400);
      } else {
        panel.classList.add('hidden');
        panel.setAttribute('aria-hidden', 'true');
        if (header) header.classList.remove('header--menu-open', 'header--saved-open');
      }
      lockTargets.forEach(function (el) { el.classList.remove('is-locked'); });
    }
    function toggle() { if (isOpen()) close(); else open(); }

    /* ---- events ----------------------------------------------------- */
    // Save buttons anywhere in the document (product cards + PDP).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-wishlist-toggle');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-product-id');
      if (!id) return;

      var list = read();
      var at = indexOf(list, id);
      if (at !== -1) {
        list.splice(at, 1);
      } else {
        list.push({
          id: id,
          title: btn.getAttribute('data-product-title') || '',
          url: btn.getAttribute('data-product-url') || '',
          image: btn.getAttribute('data-product-image') || '',
          price: btn.getAttribute('data-product-price') || ''
        });
      }
      write(list);
      render();
      open();
    });

    // Header save icon → open/close the drawer.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.js-saved-trigger');
      if (!trigger) return;
      e.preventDefault();
      toggle();
    });

    // Opening the cart (or adding to cart) closes the Saved drawer so only one
    // panel is ever open — covers mobile, where the outside-click handler is off.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-cart-trigger, .js-add-to-cart')) close();
    });

    // Remove a line from inside the panel.
    panel.addEventListener('click', function (e) {
      var rm = e.target.closest('.js-saved-remove');
      if (!rm) return;
      e.preventDefault();
      var li = rm.closest('.js-saved-item');
      if (!li) return;
      var list = read();
      var at = indexOf(list, li.getAttribute('data-id'));
      if (at !== -1) { list.splice(at, 1); write(list); }
      render();
    });

    // Close buttons: the in-panel close (mobile) and the header close (desktop,
    // shown via .header--saved-open). The header button lives outside the panel.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-saved-panel-close, .js-saved-panel-close-header')) {
        e.preventDefault();
        close();
      }
    });

    // Close on outside click (desktop) — mirrors cart-panel.js.
    document.addEventListener('mousedown', function (e) {
      if (isMobile() || panel.classList.contains('hidden')) return;
      if (e.target.closest('[data-saved-panel], .js-saved-trigger, .js-wishlist-toggle')) return;
      close();
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // Swipe-down to close (mobile) — mirrors cart-panel.js.
    var dragHandle = panel.querySelector('.js-saved-panel-drag-handle');
    if (dragHandle) {
      var startY = 0, currentY = 0, dragging = false;
      var onStart = function (y) {
        if (!panel.classList.contains('is-open')) return;
        startY = y; currentY = 0; dragging = true;
        panel.classList.add('is-dragging');
      };
      var onMove = function (y) {
        if (!dragging) return;
        currentY = Math.max(0, y - startY);
        panel.style.transform = 'translateY(' + currentY + 'px)';
      };
      var onEnd = function () {
        if (!dragging) return;
        dragging = false;
        panel.classList.remove('is-dragging');
        if (currentY > 80) close(); else panel.style.transform = '';
      };
      dragHandle.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientY); }, { passive: true });
      dragHandle.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientY); }, { passive: true });
      dragHandle.addEventListener('touchend', onEnd);
      dragHandle.addEventListener('touchcancel', onEnd);
    }

    // Reset across the mobile/desktop breakpoint, like cart-panel.js.
    var lastIsMobile = isMobile();
    window.addEventListener('resize', function () {
      if (panel.classList.contains('is-open')) updatePanelTop();
      var nowMobile = isMobile();
      if (nowMobile === lastIsMobile) return;
      lastIsMobile = nowMobile;
      panel.classList.remove('is-open', 'is-dragging');
      panel.style.transform = '';
      panel.classList.add('hidden');
      panel.setAttribute('aria-hidden', 'true');
      if (header) header.classList.remove('header--menu-open', 'header--saved-open');
      lockTargets.forEach(function (el) { el.classList.remove('is-locked'); });
    });

    render();
  }

  /* Keep the header (and every panel nested inside it) on-screen whenever scroll
   * is locked. On scroll-down the fixed header slides up via .header--hidden;
   * opening any side panel from the page body would then render it translated
   * off-screen with the header. The bundled header-scroll module already refuses
   * to re-hide the header while .is-locked is set — it just doesn't clear it at
   * the moment of locking. This watches for that lock and un-hides the header,
   * covering the cart, search and filter panels too (not just Saved). */
  function keepHeaderVisibleWhenLocked() {
    var header = document.querySelector('.header');
    if (!header || !window.MutationObserver) return;
    var root = document.documentElement;
    var sync = function () {
      if (root.classList.contains('is-locked')) header.classList.remove('header--hidden');
    };
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function start() {
    keepHeaderVisibleWhenLocked();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
